function getConfig() {
    switch (process.env.REACT_APP_ENV) {
        case 'prod': {
            return {
                backendUrl: 'https://www.vivigas.it/wordpress',
                callMeBackUrl: 'https://www.vivigas.it/laravel/api/callmeback',
                ProductAklamioArray: ['13094', '13097', '13099']
            }
        }
        case 'preprod': {
            return {
                backendUrl: 'https://dev.vivigas.alkemy.com/wordpress',
                callMeBackUrl: 'https://vivigas.alkemy.com/laravel/api/callmeback',
                ProductAklamioArray: ['8789', '8782', '8777']
            }
        }
        
        case 'local': {
            return {
                backendUrl: 'http://vivigas.local/wordpress',
                callMeBackUrl: 'https://dev.vivigas.alkemy.com/laravel/api/callmeback',
                ProductAklamioArray: ['8789', '8782', '8777']
            }
        }
        case 'dev':
        default: {
            return {
                backendUrl: 'https://dev.vivigas.alkemy.com/wordpress',
                callMeBackUrl: 'https://www.teleperformance.it/C2C_APIs/api/authentication/CallMe?',
                ProductAklamioArray: ['8789', '8782', '8777']
            }
        }
    }
}

export const ENV_VARIABLES = getConfig();